<script setup lang="ts">
import { ref, watch } from "vue";
import { FormCorporate } from "./types";
import Corporate from "@/domains/home/services/nir/forms/components/widgets/Corporate.vue";

const props = defineProps({
  cardinality: {
    type: String,
    required: true,
    default: 'SINGLE',
  },
  active: Boolean,
  modelValue: {
    type: Array as () => FormCorporate[],
    default: () => [],
  },
  data: {
    type: Array as () => FormCorporate[],
    default: () => [],
  },
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: FormCorporate[]): void
}>()

const individuals = ref<FormCorporate[]>([
  {
    registrationNumber: '',
    name: '',
    registrationDate: '',
    countryId:'',
    email: '',
    phone: '',
    address: {
      districtId: '',
      countyId: '',
      subCountyId: '',
      parishId: '',
      villageId: '',
      description: ""
    },
  },
])

watch(
  individuals,
  (newValue) => {
    emit('update:modelValue', newValue)
  },
  { deep: true },
)


watch(() => props.data, () => {
  individuals.value = props.data
})

function addIndividual() {
  individuals.value.push({
    name:'',
    registrationDate:'',
    registrationNumber:'',
    countryId:'',
    email: '',
    phone: '',
    address: {
      districtId: '',
      countyId: '',
      subCountyId: '',
      parishId: '',
      villageId: '',
      description: ""
    },
  })
}

function removeIndividual(index: number) {
  if (index > 0) {
    individuals.value.splice(index, 1)
  }
}

function updateIndividual(index: number, value: FormCorporate) {
  individuals.value[index] = value
}

</script>

<template>
  <div class="flex flex-col space-y-3 border border-gray-200 rounded-lg p-2">
    <div
      v-for="(individual, index) in individuals"
      :key="index">
      <div class="flex items-center justify-between mb-3">
        <span class="text-sm font-semibold text-gray-700">
          <i class="fa-solid fa-user mr-2 text-gray-400"></i>
          Entity {{ cardinality === "SINGLE" ? "" : index + 1 }}
        </span>
        <button
          v-if="index > 0"
          type="button"
          @click="removeIndividual(index)"
          class="btn-sm-danger"
          title="Remove individual">
          <i class="fa-solid fa-trash"></i>
        </button>
      </div>

      <Corporate :active="active" :modelValue="individual" @update:modelValue="updateIndividual(index, $event)" />
    </div>

    <!-- Add Individual Button -->
    <button
      v-if="cardinality === 'MULTIPLE'"
      type="button"
      @click="addIndividual"
      class="btn-dashed">
      <i class="fa-solid fa-plus"></i>
      <span>Add Another Individual</span>
    </button>
  </div>
</template>

<style scoped></style>
